import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
